import React, { useCallback, useState } from "react";
import { isEmpty } from "@util/utils";
import useSecurityMaskApi from "@apis/useSecurityMaskApi";
import { PrivacyDataToggleButton } from "@icoach/components";
import { Tooltip } from "@curves/ui-base";

export const securityMaskFilterTypeMap = {
	PjReport: 1,   //營運報表PJ
	CaReport: 2,   //營運報表CA

	// 會員相關報表
	ClubMemberOverview             : 100,   //會員總覽
	ClubMemberWorkoutTimes         : 101,   //次數名單
	ClubMemberRenewal              : 102,   //應續約名單
	ClubMemberSuspension           : 103,   //請假名單
	ClubMemberInvalid              : 104,   //無效名單
	ClubMemberBirthday             : 105,   //生日名單
	ClubMemberNonMeasure           : 106,   //未量身名單
	ClubMemberMeasured             : 107,   //已量身名單
	ClubMemberHundredTShirt        : 108,   //百T名單
	ClubMemberNewMember            : 109,   //新會員名單
	ClubMemberRentCabinet          : 110,   //租櫃名單
	ClubMemberHealthyChoice        : 111,   //蛋白&益菌名單
	ClubMemberOverdraft            : 112,   //欠款名單
	ClubMemberMonthFee             : 113,   //月費收費名單
	ClubMemberMeasureResult        : 114,   //量身成果名單
	ClubMemberMeasureFilter        : 115,   //會員成果查詢
	ClubMemberCyclePurchaseOverview: 116,   //循環訂單總覽
	ClubMemberHighRisk             : 121,   //續約CDE名單
	ClubMemberCrossClub            : 122,   //跨店名單

	// 顧客及其他相關報表
	ClubCustomerOverview         : 150,   //顧客總覽
	ClubCustomerTemporary        : 151,   //暫存名單
	ClubPointsRewardOverview     : 152,   //點數總覽
	ClubAppointmentOverview      : 153,   //預約管理總覽
	ClubCustomerGuestOverview    : 154,   //名單總覽
	ClubEmployeeOverview         : 155,   //員工總覽
	ClubSmsOverview              : 156,   //簡訊總覽
	ClubGiftItemRecordOverview   : 157,   //贈品領取記錄
	ClubOrderBatchPaymentOverview: 158,   //批次扣款總覽
	ClubReportAgpOverview        : 159,   //顧客製造AGP
	ClubReportCallsOverview      : 160,   //顧客製造CALLS
	ClubReportApoOverview        : 161,   //顧客製造APO
	ClubReportTotalSalesOverview : 162,   //顧客製造入會
	ClubPointsRedeemdOverview    : 163,   //贈品兌換總覽

	// 總部（HQ）相關報表
	HqPointsRewardOverview: 200,   //HQ點數總覽
	HqPointsRewardOrders  : 201,   //HQ點數贈品配送
};

const usePrivacyToggle = (initialIsRevealed = false) => {
	const [isRevealed, setIsRevealed] = useState(initialIsRevealed);
	const { postSecurityMaskApi }     = useSecurityMaskApi();

	const toggle = useCallback(
		logParams => {
			setIsRevealed(prevState => {
				const nextState = !prevState;

				// 當狀態變為 true 時，執行 logApi
				if (nextState && !isEmpty(logParams)) {
					postSecurityMaskApi(logParams);
				}

				return nextState;
			});
		},
		// eslint-disable-next-line
		[postSecurityMaskApi]
	);

	const hide = useCallback(
		() => {
			if (isRevealed) {
				setIsRevealed(false);
			}
		},
		// eslint-disable-next-line
		[isRevealed]
	);

	const show = useCallback(
		logParams => {
			if (!isRevealed) {
				if (!isEmpty(logParams)) {
					postSecurityMaskApi(logParams);
				}
				setIsRevealed(true);
			}
		},
		// eslint-disable-next-line
		[isRevealed, postSecurityMaskApi]
	);

	const renderTooltip = (handleToggle, className) => {
		return (
			<Tooltip                 title     = {isRevealed ? "隱蔽資料" : "顯示完整資料"}>
			<PrivacyDataToggleButton className = {className} isRevealed = {isRevealed} onToggle = {handleToggle} />
			</Tooltip>
		);
	};

	return {
		isRevealed,
		toggle,
		doTogglePrivacy  : toggle,
		doHidePrivacy    : hide,
		doShowPrivacy    : show,
		renderPrivacyIcon: renderTooltip,
	};
};

export default usePrivacyToggle;
